/** @format */

import React from 'react';
import { css } from '@emotion/core';
import { FadeLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Requests from '../../../api/requests';
import ButtonPrimary from '../../components/buttons/button-primary';
import ButtonSecondary from '../../components/buttons/button-secondary';
import Modal from '../../components/modal/modal';
import PopupOneButton from '../../components/popup/popup-one-button';
import { saveAdmin } from '../../../store/actions/user-actions';
import { selectKey } from '../../../utilities/helper';
import SessionStorage from '../../../api/session-storage';
import './directions.scss';
import { cancelSpeech } from '../../../utilities/helper';

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ saveAdmin }, dispatch);
};
let timeoutID;
let msg = null;
class Directions extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
      directionsScrollPosition: 0,
      isFullyRead: false,
      scrollEnd: false,
      size: Math.round(window.innerHeight * 0.27),
      directions: '',
      index: 0,
      modalIndex: 0,
      isLoading: true,
      hasInvalidParams: false,
      hasInvalidAuthParams: false,
      hasContent: false,
      isRead: false,
      ariaHidden: false,
    };
  }

  componentDidMount = async () => {
    await cancelSpeech();
    window.addEventListener('keydown', this.keySelect);
    if (!this.props.userStore.admin || !this.props.userStore.admin.admin_id) {
      this.setState({ hasInvalidAuthParams: true });
    } else {
      const admin = {
        admin_id: this.props.userStore.admin.admin_id,
        token: this.props.userStore.admin.token,
      };
      const { ok, json: body, status } = await Requests.getDirections(admin);
      if (ok) {
        if (status === 200) {
          this.setState({
            directions: body.directions,
            isLoading: false,
            hasContent: true,
          });
        }
        const elem = document.getElementById('directions-container');
        if (elem.scrollHeight < this.state.size) {
          this.setState({ isFullyRead: true });
        }
        elem.addEventListener('scroll', () => this.setScrollPosition(elem));
        window.addEventListener('resize', this.setSize);
      } else {
        if (status === 400 || status === 403) {
          this.setState({ hasInvalidParams: true });
        }
      }

      setTimeout(() => {
        if (document.getElementById('scroll')) {
          document.getElementById('scroll');
        }
      }, 50);
      setTimeout(() => {
        this.scrollToTop();
      }, 100);
    }
  };

  async componentWillUnmount() {
    if (window.speechSynthesis.speaking || window.speechSynthesis.paused) {
      await cancelSpeech();
      msg = null;
    }
    clearTimeout(timeoutID);
    timeoutID = 0;
    window.removeEventListener('keydown', this.keySelect);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.isFullyRead === false && this.state.isFullyRead === true) {
      if (window.speechSynthesis.speaking) {
        await cancelSpeech();
        msg = null;
      }
    }
  }

  setSize = () => {
    this.setState({ size: Math.round(window.innerHeight * 0.27) });
  };

  setScrollPosition = elem => {
    this.setState({ directionsScrollPosition: elem.scrollTop });
    if (
      elem.scrollTop + this.state.size <= elem.scrollHeight + 2 &&
      elem.scrollHeight - 2 <= elem.scrollTop + this.state.size
    ) {
      this.setState({ scrollEnd: true });
    } else {
      this.setState({ scrollEnd: false });
    }
  };

  scrollDown = () => {
    const element = document.getElementById('directions-container');
    element.scrollTop =
      this.state.directionsScrollPosition + (this.state.size - 90);
  };

  scrollToBottom = () => {
    const element = document.getElementById('directions-container');
    element.scrollTop = element.scrollHeight;
  };

  scrollToTop = () => {
    const element = document.getElementById('directions-container');
    element.scrollTop = 0;
  };

  getNavigationKeys = () => {
    const button = !this.state.isRead ? 'button-primary' : 'button-secondary';
    const directionsNotFullyRead = this.state.isRead
      ? ['scroll', 'logout', 'directions-text', button]
      : ['scroll', 'logout', button];
    return directionsNotFullyRead;
  };

  keySelect = event => {
    const ids = this.getNavigationKeys();
    let i;
    const focusedElement = document.activeElement.id;
    const isModalOpen = this.props.headerStore.isModalOpen;
    if (
      this.state.index <= ids.length - 1 &&
      !this.state.modalIsOpen &&
      !isModalOpen
    ) {
      if (event.key === 'ArrowRight') {
        if (this.state.index === ids.length - 1) {
          if (focusedElement !== ids[this.state.index]) {
            const newID = ids.indexOf(focusedElement);
            i = newID + 1;
          } else {
            i = 0;
          }
          this.setState({ index: i });
          document.getElementById(ids[i]).focus();
        } else {
          if (focusedElement !== ids[this.state.index]) {
            const newID = ids.indexOf(focusedElement);
            if (ids.indexOf(focusedElement) === ids.length - 1) {
              i = 0;
            } else {
              i = newID;
            }
          } else {
            i = this.state.index;
          }
          i++;
          this.setState({ index: i });
          document.getElementById(ids[i]).focus();
        }
      }
    }

    if (event.key === 'ArrowLeft') {
      if (this.state.index === 0) {
        if (focusedElement !== ids[this.state.index]) {
          const newID = focusedElement
            ? ids.indexOf(focusedElement)
            : ids.length;
          i = newID - 1;
        } else {
          i = ids.length - 1;
        }
        this.setState({ index: ids.length - 1 });
        document.getElementById(ids[i]).focus();
      } else {
        if (focusedElement !== ids[this.state.index]) {
          const newID = focusedElement
            ? ids.indexOf(focusedElement)
            : ids.length;
          if (ids.indexOf(focusedElement) === 0) {
            i = ids.length;
          } else {
            i = newID;
          }
        } else {
          i = this.state.index;
        }
        i--;
        this.setState({ index: i });

        document.getElementById(ids[i]).focus();
      }
    }
  };

  setModalIndex = index => {
    this.setState({ modalIndex: index });
  };

  closeErrorModal = () => {
    this.props.history.push('/');
    SessionStorage.clearStorage();
  };

  modalNavigation = event => {
    const ids = ['button-primary-modal', 'close-modal'];

    const focusedElement = document.activeElement.id;
    const arrows = ['ArrowDown', 'ArrowUp'];
    if (this.state.modalIndex <= ids.length - 1 && this.state.modalIndex >= 0) {
      selectKey(
        event,
        this.state.modalIndex,
        ids,
        focusedElement,
        this.setModalIndex,
        arrows,
      );
    }
  };

  focusDirections = async () => {
    if (msg && window.speechSynthesis.paused) {
      window.speechSynthesis.resume();
      window.speechSynthesis.speak(msg);
    } else {
      let filteredDirections = this.state.directions
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replace(/(&.*?;)/gi, ' ')
        .replace('&nbsp;', ' ')
        .replace(/\n/g, ' ')
        .replace('ACT', 'A C T')
        .trim();

      if (msg) {
        window.speechSynthesis.resume();
        window.speechSynthesis.speak(msg);
      } else {
        await cancelSpeech();
        msg = this.initSpeech(filteredDirections);
        window.speechSynthesis.speak(msg);
      }
    }
    document.getElementById('directions-text').tabIndex = 8;
    this.setState({
      isRead: true,
    });
    document
      .getElementById('directions-text')
      .setAttribute('aria-hidden', 'false');
    setTimeout(() => {
      document.getElementById('directions-text').focus();
    }, 100);
  };

  initSpeech = text => {
    let msg = new SpeechSynthesisUtterance();
    msg.addEventListener('end', e => {
      this.setState({ isFullyRead: true, isRead: false });
    });
    msg.text = text;
    return msg;
  };

  stopDirections = () => {
    window.speechSynthesis.pause();
    document.getElementById('directions-text').tabIndex = -1;
    this.setState({
      isRead: false,
    });

    setTimeout(() => {
      document
        .getElementById('directions-text')
        .setAttribute('aria-hidden', 'true');
      if (document.getElementById('button-primary')) {
        document.getElementById('button-primary').focus();
      } else {
        document.getElementById('button-secondary').focus();
      }
    }, 200);
  };

  scrollFocus = event => {
    if (event.key === 'Enter') {
      this.scrollDown();
    }
  };

  render() {
    const directions = this.state.directions ? this.state.directions : '';
    const override = css`
      display: block;
      margin: 0 auto;
    `;

    const filteredDirections = directions
      .replace(/<\/?[^>]+(>|$)/g, '')
      .replace(/(&.*?;)/gi, ' ')
      .replace('&nbsp;', ' ')
      .replace(/\n/g, ' ')
      .replace('ACT', 'A C T')
      .trim();
    return (
      <div className="directions">
        {this.state.hasContent ? (
          <div
            className="directions-container"
            id="directions-container"
            style={{ maxHeight: this.state.size }}
          >
            <div
              className="directions-text"
              id="directions-text"
              role="textbox"
              aria-label={filteredDirections}
            >
              <div
                aria-hidden="true"
                dangerouslySetInnerHTML={{
                  __html: directions,
                }}
              ></div>
            </div>
            <div className="buttons-container">
              {!this.state.isRead ? (
                <>
                  <ButtonPrimary
                    ariaHidden={this.state.ariaHidden}
                    aria-live="assertive"
                    aria-label="Read Aloud"
                    buttonText="Read Aloud"
                    hasArrow={false}
                    hasPlay="play"
                    onClick={this.focusDirections}
                    tabIndex={0}
                  />
                </>
              ) : (
                <ButtonSecondary
                  buttonText="Read Aloud"
                  hasArrow={false}
                  onClick={this.stopDirections}
                  tabIndex={0}
                  hasPlay="stop"
                  ariaHidden={this.state.ariaHidden}
                  aria-live="assertive"
                />
              )}
              {!this.state.scrollEnd && (
                <div
                  className="scroll"
                  id="scroll"
                  tabIndex={0}
                  aria-label="scroll down"
                  onKeyUp={this.scrollFocus}
                  role="application"
                >
                  <div
                    className="scroll-button"
                    onClick={this.scrollDown}
                    aria-hidden="true"
                  ></div>
                  <div className="scroll-text" aria-hidden="true">
                    SCROLL DOWN
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div>
            <div className="spinner-container">
              <FadeLoader
                css={override}
                size={'350px'}
                sizeUnit="px"
                color="#042E60"
                loading={this.state.loading}
                height={30}
                width={7}
                margin={20}
              />
            </div>
            <Modal
              isOpen={this.state.hasInvalidParams}
              className={'modal-content one-button'}
              ariaProps={{
                modal: true,
              }}
              child={
                <PopupOneButton
                  title="Error"
                  description="Something went wrong. Please try again"
                  buttonText="Go To Sign In"
                  padding="0 75px"
                  onClick={this.closeErrorModal}
                />
              }
            />
            <Modal
              isOpen={this.state.hasInvalidAuthParams}
              className={'modal-content one-button'}
              ariaProps={{
                modal: true,
              }}
              child={
                <PopupOneButton
                  title="Error"
                  description="You need to be logged in to access this page."
                  buttonText="Go To Sign In"
                  padding="0 75px 30px"
                  onClick={this.closeErrorModal}
                />
              }
            />
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Directions);
